import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import SvgIcon from "@material-ui/core/SvgIcon";
import Typography from "@material-ui/core/Typography";
import { fixUrlLanguage } from "@utils/changeLanguage";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { BRAND_NAME, WORDPRESS_URL,ROUTES } from "../../constants";
import { ContactModal } from "./ContactModal";
import "./css/Footer.scss";
import {
    facebookIcon,
    facebookUrl,
    instagramIcon,
    instagramUrl,
    twitterIcon,
    twitterUrl,
    tiktokIcon,
    tiktokUrl,
    youtubeIcon,
    youtubeUrl,
} from "./footerConstant";

export const Footer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation("footer");

    const links = [
        {
            title: t("terms"),
            url: `${WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_TERM_URL_EN)}`,
        },
        {
            title: t("charges"),
            url: `${WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_PRICING_URL_EN)}`,
        },
        {
            title: t("roaming"),
            url: `${WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_ROAMING_URL_EN)}`,
        },
        {
            title: t("privacy"),
            url: `${WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_PRIVACY_URL_EN)}`,
        },
        {
            title: t("legal"),
            url: `${WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_LEGAL_URL_EN)}`,
        },
        {
            title: t("topFAQs"),
            url: `${WORDPRESS_URL + fixUrlLanguage(ROUTES.WORDPRESS_GETTING_STARTED_URL_EN)}`,
        },
    ];

    const footerLinks = links.map(({ url, title }, index) => (
        <Typography data-testid="footer-link" key={title}>
            <Link color="primary" href={url} underline="none">
                {title}
            </Link>
            {links.length !== index + 1 && <span>&#124;</span>}
        </Typography>
    ));

    return (
        <Fragment>
            <ContactModal isOpen={isOpen} setIsOpen={setIsOpen} />
            <footer className="footer">
                <Grid alignItems="center" className="footer-wrapper" container>
                    <Grid item md={8} xs={12}>
                        <div className="footer-wrapper__links">{footerLinks}</div>
                    </Grid>
                    <Grid className="footer-wrapper-brand" item md={4} xs={12}>
                        <Link aria-label="Facebook" href={facebookUrl} rel="noreferrer" target="_blank">
                            <SvgIcon className="footer-wrapper-brand__facebook" color="secondary" viewBox="0 0 16 28">
                                <path d={facebookIcon} />
                            </SvgIcon>
                        </Link>
                        <Link aria-label="Tiktok" href={tiktokUrl} rel="noreferrer" target="_blank">
                            <SvgIcon className="footer-wrapper-brand__tiktok" color="inherit" viewBox="0 0 24 24">
                                <path d={tiktokIcon} />
                            </SvgIcon>
                        </Link>
                        <Link aria-label="Instagram" href={instagramUrl} rel="noreferrer" target="_blank">
                            <SvgIcon className="footer-wrapper-brand__instagram" color="inherit" viewBox="0 0 448 512">
                                <path d={instagramIcon} />
                            </SvgIcon>
                        </Link>
                        <Link aria-label="Youtube" href={youtubeUrl} rel="noreferrer" target="_blank">
                            <SvgIcon className="footer-wrapper-brand__youtube" color="inherit" viewBox="0 0 576 512">
                                <path d={youtubeIcon} />
                            </SvgIcon>
                        </Link>
                    </Grid>
                    {/* this button is used with oneTrust */}
                    <Grid className="footer-wrapper-cookie" item xs={12}>
                        <a
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained xtest_tac_button MuiButton-containedSecondary MuiButton-containedSizeLarge MuiButton-sizeLarge"
                          id="ot-sdk-btn"
                          href="#"
                          onClick={(e) => {
                              e.preventDefault();
                              (window as any).__ucCmp?.showSecondLayer?.();
                          }}
                        >
                            {t("cookieSettings")}
                        </a>
                    </Grid>
                </Grid>
            </footer>
        </Fragment>
    );
};
